import Div from "@jumbo/shared/Div";
import { Button, InputAdornment, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ListSupplierTable from "./supplierTable";
import { getAllSuppliers } from "app/redux/actions/masterAction";
import { useDispatch } from "react-redux";

export default function ListSupplier() {
  const [searchTerm, setSearchTerm] = useState("");
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const handleSearch = (value) => {
    dispatch(getAllSuppliers(value, 1));
  };
  useEffect(() => {
    dispatch(getAllSuppliers("", page));
  }, []);

  return (
    <Div sx={{ mt: -4 }}>
      <Typography variant="h1">Supplier Master</Typography>
      <Div
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <TextField
          size="small"
          id="search"
          type="search"
          label="Search"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            handleSearch(e.target.value);
          }}
          sx={{ width: 300, mb: 5, mt: 4 }}
          InputProps={{
            endAdornment: (
              <Div sx={{ cursor: "pointer" }}>
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              </Div>
            ),
          }}
        />
        {permissions?.supplier_master_create == true && (
          <Div>
            <Button
              variant="contained"
              sx={{ p: 1, pl: 4, pr: 4 }}
              onClick={() => navigate("/master/supplier/add")}
            >
              Add New Supplier
            </Button>
          </Div>
        )}
      </Div>
      <ListSupplierTable
        searchTerm={searchTerm}
        setPage={setPage}
        page={page}
      />
    </Div>
  );
}
